import type React from 'react';
import { FieldSet, Heading, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';

interface Props {
  question: {
    index: number;
    text: string;
    choices: Array<{ text: string; index: number; chosen: boolean }>;
    answered: boolean;
  };
  chooseAnswer: (index: number) => void;
}

const QuestionPage: React.FC<Props> = ({ question, chooseAnswer }) => {
  const groupName = `kba-question-${question.index}`;

  return (
    <>
      <Heading level={3} textStyle="body-lg-bold">
        Question {question.index + 1}
      </Heading>
      <FieldSet legend={<Legend>{question.text}</Legend>}>
        {question.choices.map((choice) => (
          <LabeledControl
            key={choice.index}
            controlId={`${groupName}-choice-${choice.index}`}
            control={
              <Radio
                name={groupName}
                value={String(choice.index)}
                checked={choice.chosen}
                onChange={() => chooseAnswer(choice.index)}
              />
            }
            label={<Label>{choice.text}</Label>}
          />
        ))}
      </FieldSet>
    </>
  );
};

export default QuestionPage;
